import { FormattedMessage, IntlProvider } from "react-intl";
import projectsMessages from "../translate/projectsMessages";
import { useContext, useState } from "react";
import { LangContext } from "../App";
import tomek from "../images/pfTomek.png";
import nurek from "../images/pfNurek.png";
import pzitb from "../images/pfPzitb.png";
import pfOpiekunka from "../images/pfOpiekunka.png";
import kasia from "../images/pfKasia.png";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import ImageZoom from "../components/ImageZoom";
import { motion, AnimatePresence } from "framer-motion";
import { textVariants } from "../components/textVariants";
import CheckIcon from "@mui/icons-material/Check";
import { Helmet } from "react-helmet-async";

const Job = () => {
  const language = useContext(LangContext);
  const [showText1, setShowText1] = useState(false);
  const [showText2, setShowText2] = useState(false);
  const [showText3, setShowText3] = useState(false);
  const [showText4, setShowText4] = useState(false);
  const [showText5, setShowText5] = useState(false);

  const styles = {
    wrapper: {
      backgroundColor: "#f8fafc",
      minHeight: "100vh",
      padding: "80px 24px 60px 24px",
      fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    },
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      width: "100%",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))",
      gap: "32px",
      alignItems: "start",
    },
    projectCard: {
      background: "#ffffff",
      borderRadius: "20px",
      padding: "24px",
      boxShadow: "0 4px 30px -10px rgba(0,0,0,0.03)",
      border: "1px solid #e2e8f0",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      overflow: "hidden",
    },
    imageWrapper: {
      width: "100%",
      borderRadius: "12px",
      overflow: "hidden",
      backgroundColor: "#f1f5f9",
      aspectRatio: "16 / 10",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    projectTitle: {
      fontSize: "18px",
      fontWeight: "700",
      color: "#0f172a",
      margin: 0,
    },
    projectDescription: {
      fontSize: "14px",
      color: "#475569",
      lineHeight: "1.6",
      margin: 0,
      backgroundColor: "#f8fafc",
      padding: "16px",
      borderRadius: "12px",
      border: "1px solid #f1f5f9",
    },
    projectLink: {
      color: "#6366f1",
      fontWeight: "600",
      textDecoration: "none",
      display: "inline-block",
      marginTop: "8px",
    },
    experienceCard: {
      background: "#ffffff",
      borderRadius: "20px",
      padding: "32px",
      boxShadow: "0 4px 30px -10px rgba(0,0,0,0.03)",
      border: "1px solid #e2e8f0",
    },
    experienceTitle: {
      fontSize: "22px",
      fontWeight: "800",
      color: "#0f172a",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginBottom: "24px",
    },
    experienceList: {
      listStyleType: "none",
      padding: 0,
      margin: 0,
      display: "flex",
      flexDirection: "column",
      gap: "18px",
    },
    experienceItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      fontSize: "14.5px",
      color: "#334155",
      lineHeight: "1.5",
    },
    checkIcon: {
      color: "#10b981",
      fontSize: "20px",
      flexShrink: 0,
      marginTop: "2px",
    },
  };

  return (
    <>
      <Helmet>
        <title>Projekty | Realizacje</title>
        <meta
          name="description"
          content="Zestawienie ostatnich projektów i realizacji"
        />
      </Helmet>

      <div className="bodyBackground" style={styles.wrapper}>
        <IntlProvider locale={language} messages={projectsMessages[language]}>
          <AnimatePresence>
            <motion.div
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={textVariants}
              style={styles.container}
            >
              <div style={styles.grid}>
                {/* Projekt 1 */}
                <div style={styles.projectCard}>
                  <h3 style={styles.projectTitle}>
                    {language === "pl"
                      ? "Galeria nieruchomości"
                      : "Real estate photo gallery"}
                  </h3>
                  <div style={styles.imageWrapper}>
                    <ImageZoom
                      src={tomek}
                      alt="Tomasz Fotograf"
                      onClick={() => setShowText1(!showText1)}
                    />
                  </div>
                  {showText1 && (
                    <div style={styles.projectDescription}>
                      {language === "pl" ? (
                        <>
                          Galeria fotografii nieruchomości dla znanego
                          producenta filmowego i fotografa wnętrz. Umożliwia
                          samodzielne dodawanie, ukrywanie i sortowanie zdjęć.
                          <br />
                          <a
                            href="https://tomaszfotograf.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            tomaszfotograf.pl &rarr;
                          </a>
                        </>
                      ) : (
                        <>
                          Real estate photography gallery for a renowned film
                          producer and photographer. Allows adding, hiding, and
                          sorting photos dynamically.
                          <br />
                          <a
                            href="https://tomaszfotograf.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            tomaszfotograf.pl &rarr;
                          </a>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* Projekt 2 */}
                <div style={styles.projectCard}>
                  <h3 style={styles.projectTitle}>
                    {language === "pl"
                      ? "Strona rzeczoznawcy budowlanego"
                      : "Construction appraiser's website"}
                  </h3>
                  <div style={styles.imageWrapper}>
                    <ImageZoom
                      src={nurek}
                      alt="Agur"
                      onClick={() => setShowText2(!showText2)}
                    />
                  </div>
                  {showText2 && (
                    <div style={styles.projectDescription}>
                      {language === "pl" ? (
                        <>
                          Statyczna strona internetowa dla rzeczoznawcy
                          budowlanego i biegłego sądowego.
                          <br />
                          <a
                            href="https://agur.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            agur.pl &rarr;
                          </a>
                        </>
                      ) : (
                        <>
                          Static website for a construction appraiser and
                          court-appointed expert.
                          <br />
                          <a
                            href="https://agur.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            agur.pl &rarr;
                          </a>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* Projekt 3 */}
                <div style={styles.projectCard}>
                  <h3 style={styles.projectTitle}>
                    {language === "pl"
                      ? "System obsługi zleceń w PZITB"
                      : "The system for processing orders from construction engineers"}
                  </h3>
                  <div style={styles.imageWrapper}>
                    <ImageZoom
                      src={pzitb}
                      alt="PZITB"
                      onClick={() => setShowText3(!showText3)}
                    />
                  </div>
                  {showText3 && (
                    <div style={styles.projectDescription}>
                      {language === "pl" ? (
                        <>
                          Internetowa aplikacja w celu kompleksowej obsługi
                          zleceń dla PZITB.
                          <br />
                          <a
                            href="https://pzitbrz.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            pzitbrz.pl &rarr;
                          </a>
                        </>
                      ) : (
                        <>
                          Online application for comprehensive processing of
                          orders for PZITB.
                          <br />
                          <a
                            href="https://pzitbrz.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            pzitbrz.pl &rarr;
                          </a>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* Projekt 4 */}
                <div style={styles.projectCard}>
                  <h3 style={styles.projectTitle}>
                    {language === "pl" ? "Twoja opiekunka" : "Your caregiver"}
                  </h3>
                  <div style={styles.imageWrapper}>
                    <ImageZoom
                      src={pfOpiekunka}
                      alt="Twoja opiekunka"
                      onClick={() => setShowText4(!showText4)}
                    />
                  </div>
                  {showText4 && (
                    <div style={styles.projectDescription}>
                      {language === "pl" ? (
                        <>
                          TwojaOpiekunka.pl to autorski projekt platformy
                          internetowej łączącej osoby poszukujące opieki z
                          opiekunkami osób starszych. Aplikacja oferuje m.in.
                          wyszukiwanie opiekunek, system weryfikacji oraz dostęp
                          do ofert pracy i artykułów. Projekt realizowany z
                          wykorzystaniem React.js, PHP (Slim Framework) i MySQL.
                          <br />
                          <a
                            href="https://twojaopiekunka.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            twojaopiekunka.pl &rarr;
                          </a>
                        </>
                      ) : (
                        <>
                          TwojaOpiekunka.pl is a web platform connecting people
                          looking for elderly care with professional caregivers.
                          It provides features such as caregiver search, a
                          verification system, job listings and informative
                          articles. The project is developed using React.js, PHP
                          (Slim Framework) and MySQL.
                          <br />
                          <a
                            href="https://twojaopiekunka.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            twojaopiekunka.pl &rarr;
                          </a>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* Projekt 5 */}
                <div style={styles.projectCard}>
                  <h3 style={styles.projectTitle}>
                    {language === "pl"
                      ? "System obsługi plików księgowych"
                      : "Accounting file management system"}
                  </h3>
                  <div style={styles.imageWrapper}>
                    <ImageZoom
                      src={kasia}
                      alt="Księgowa Katarzyna"
                      onClick={() => setShowText5(!showText5)}
                    />
                  </div>
                  {showText5 && (
                    <div style={styles.projectDescription}>
                      {language === "pl" ? (
                        <>
                          System wspomagający codzienną pracę biura
                          rachunkowego. W przygotowaniu integracja z KSeF.
                          <br />
                          <a
                            href="https://ksiegowakatarzyna.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            ksiegowakatarzyna.pl &rarr;
                          </a>
                        </>
                      ) : (
                        <>
                          The system supporting the daily work of an accounting
                          office. KSeF integration is in preparation.
                          <br />
                          <a
                            href="https://ksiegowakatarzyna.pl"
                            style={styles.projectLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            ksiegowakatarzyna.pl &rarr;
                          </a>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* Karta z pozostałym doświadczeniem */}
                <div style={styles.experienceCard}>
                  <h3 style={styles.experienceTitle}>
                    <VerifiedRoundedIcon
                      style={{ color: "#6366f1", fontSize: "26px" }}
                    />
                    <FormattedMessage id="projects" />
                  </h3>
                  <ul style={styles.experienceList}>
                    <li style={styles.experienceItem}>
                      <CheckIcon style={styles.checkIcon} />
                      <span>
                        {language === "pl"
                          ? "Udział w projekcie konsolidacji danych dwóch operatorów telekomunikacyjnych"
                          : "Participation in a project to consolidate data between two telecommunications operators"}
                      </span>
                    </li>
                    <li style={styles.experienceItem}>
                      <CheckIcon style={styles.checkIcon} />
                      <span>
                        {language === "pl"
                          ? "Udział w projekcie e-commerce dla jednej z największych firm kosmetycznych"
                          : "Participation in an e-commerce project for one of the largest cosmetics companies"}
                      </span>
                    </li>
                    <li style={styles.experienceItem}>
                      <CheckIcon style={styles.checkIcon} />
                      <span>
                        {language === "pl"
                          ? "Zaprojektowanie i wdrożenie systemu ERP dla średniego przedsiębiorstwa"
                          : "Design and implementation of an ERP system for a medium-sized enterprise"}
                      </span>
                    </li>
                    <li style={styles.experienceItem}>
                      <CheckIcon style={styles.checkIcon} />
                      <span>
                        {language === "pl"
                          ? "Utrzymanie i rozwój systemu finansowo-księgowego dla międzynarodowej organizacji"
                          : "Maintaining and developing a financial accounting system for an international organization"}
                      </span>
                    </li>
                    <li style={styles.experienceItem}>
                      <CheckIcon style={styles.checkIcon} />
                      <span>
                        {language === "pl"
                          ? "Zaprojektowanie i wdrożenie aplikacji monitorującej bieżącą sprzedaż zastępującej arkusze excelowe dla operatora telekomunikacyjnego"
                          : "Design and implementation of a sales monitoring application replacing Excel spreadsheets for a telecommunications operator"}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </IntlProvider>
      </div>
    </>
  );
};

export default Job;
